// extracted by mini-css-extract-plugin
export default {"index":"stocks_index__1+UWC","action-filter-buttons":"stocks_action-filter-buttons__XZiJv","separator":"stocks_separator__qFCOT"};